import React from "react";
import Field from "./shared/Field";

export default function GenericSectionEditor({ config, hasKey, onChange }) {
  const cfg = config || {};
  const has = hasKey || ((k) => Object.prototype.hasOwnProperty.call(cfg, k));

  const show = (key) => has(key) || cfg?.[key] !== undefined;

  return (
    <div className="space-y-6">
      {(show("title") || show("subtitle")) && (
        <div className="space-y-4">
          <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Header</h3>

          {show("title") && (
            <Field label="Title" value={cfg.title} onChange={(v) => onChange("title", v)} />
          )}

          {show("subtitle") && (
            <Field
              label="Subtitle"
              type="textarea"
              value={cfg.subtitle}
              onChange={(v) => onChange("subtitle", v)}
            />
          )}
        </div>
      )}

      {(show("buttonText") || show("secondaryButtonText") || show("buttonLink") || show("secondaryButtonLink")) && (
        <div className="space-y-4">
          <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Buttons</h3>

          {show("buttonText") && (
            <Field
              label="Primary Button Text"
              value={cfg.buttonText}
              onChange={(v) => onChange("buttonText", v)}
            />
          )}

          {show("buttonLink") && (
            <Field
              label="Primary Button Link"
              value={cfg.buttonLink}
              onChange={(v) => onChange("buttonLink", v)}
            />
          )}

          {show("secondaryButtonText") && (
            <Field
              label="Secondary Button Text"
              value={cfg.secondaryButtonText}
              onChange={(v) => onChange("secondaryButtonText", v)}
            />
          )}

          {show("secondaryButtonLink") && (
            <Field
              label="Secondary Button Link"
              value={cfg.secondaryButtonLink}
              onChange={(v) => onChange("secondaryButtonLink", v)}
            />
          )}
        </div>
      )}
    </div>
  );
}
